import { API, AnyObject, snakeify } from "@thenounproject/lingo-core";
import { createAsyncAction } from "@actions/actionCreators";
import deepPick from "@helpers/deepPick";

type Args = {
  itemId: string;
  updates: {
    data?: {
      content?: string;
      /// Title of the guide
      title?: string;
      /// Color of the guide
      color?: string;
      codeLanguage?: string;
      /// Used for galleries
      name?: string;
    };
    viewId?: number;
    assetUuid?: string;
  };
};

const [useUpdateItem, updateItem] = createAsyncAction(
  {
    action: "items/update",
    undo: {
      message: () => "Updated item",
      captureState: ({ itemId, updates }: Args, { getState }) => {
        const item = getState().entities.items.objects[`${itemId}-0`];
        return item ? deepPick(item as Record<string, unknown>, updates) : {};
      },
      performUndo: ({ itemId }: Args, captured: unknown, { dispatch }) => {
        void dispatch(updateItem({ itemId, updates: captured as AnyObject }));
      },
    },
  },
  async ({ itemId, updates }: Args) => {
    const res = await API.call<{ item: string }>({
      endpoint: `items/${itemId}`,
      method: "PUT",
      data: snakeify(updates),
    });
    return { ...res, result: res.result.item };
  }
);

export default useUpdateItem;
export { updateItem };
